module.exports = __webpack_public_path__ + "img/au-vic.dee219a6.svg";